<!--
// Copyright © 2026 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
-->

<!--
  The page toolbar (DESIGN.md §6.1): a 40 px row under the page header. Tabs
  or view modes on the left, filters, search and display options on the
  right. Content starts on the page edge.
-->
<div class="fz-toolbar">
  <div class="fz-toolbar__left"><slot /></div>
  {#if $$slots.right}
    <div class="fz-toolbar__right"><slot name="right" /></div>
  {/if}
</div>

<style lang="scss">
  .fz-toolbar {
    display: flex;
    align-items: stretch;
    justify-content: space-between;
    gap: var(--fz-space-4);
    flex-shrink: 0;
    min-width: 0;
    min-height: var(--fz-size-toolbar);
    padding: 0 var(--fz-page-padding);
    background-color: var(--fz-bg-surface);
    border-bottom: 1px solid var(--fz-border-subtle);
  }
  .fz-toolbar__left,
  .fz-toolbar__right {
    display: flex;
    align-items: center;
    gap: var(--fz-space-2);
    min-width: 0;
  }
  .fz-toolbar__left {
    flex-shrink: 1;
    overflow-x: auto;
    scrollbar-width: none;
  }
  .fz-toolbar__right {
    flex-wrap: wrap;
    justify-content: flex-end;
    padding: var(--fz-space-1) 0;
  }
</style>
